<template>
  <div class="bg-white min-h-screen mx-auto px-4">
    <div class="pt-16 pb-20">
      <Sidebar></Sidebar>
      <Header> {{$t('all.register')}} - {{classe}}
      </Header>
      <div class="flex mx-5 justify-between">
        <div
          @click="decreaseDay()"
          class="pin-l px-2 py-2 bg-red text-white"
        >
          <i class="fas fa-arrow-left fa-xs"></i>
        </div>
        <div class="flex text-center">
                <div class="relative bg-red">
                  <datepicker
                    :format="format"
                    :language="languages[$i18n.locale]"
                    :mondayFirst="true"
                    v-model="registerDate"
                    :inputClass="'bg-red text-center text-white p-2 w-full text-sm block outline-none appearance-none px-4 pr-8'"
                  ></datepicker>
                  <div class="absolute pin-y pin-r flex items-center px-2 text-white">
                    <i class="far fa-calendar-alt fa-xs"></i>
                  </div>
                </div>
              </div>
        <div
          @click="increaseDay()"
          class="pin-r px-2 py-2 bg-red text-white"
        >
          <i class="fas fa-arrow-right fa-xs"></i>
        </div>
      </div>
      <div class="pt-10 mx-5">
        <div
          v-for="event in eventsData"
          :key="event.id"
          class="mb-2 border-b-2 border-dashed border-pink"
        >
          <h4 class="text-red pb-1"> {{ event.name }} {{ event.surname }}</h4>
          <div class="flex">
            <div class="flex-wrap text-left w-4/5">
              <p class="capitalize text-sm">{{$t('all.present')}}</p>
              <p class="text-xs pb-2"> {{ getPresence(event) }} </p>
            </div>
            <div class="flex-wrap text-left w-1/5 mr-6">
              <p class="capitalize text-sm">{{$t('all.absent')}}</p>
              <p class="text-xs pb-2"> {{ getAbsence(event) }} </p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';

export default {
  name: 'Register',
  components: {
    Datepicker
  },
  data() {
    return {
      registerDate: new Date(),
      format: 'dd MMM yyyy',
      classe: '',
      classId: '',
      languages: lang
    };
  },
  computed: {
    ...mapGetters({
      eventsData: 'users/minorEvents',
    })
  },
   watch: {
    registerDate(val) {
      this.selectDate();
    },
  },
  async mounted() {
    this.classe = this.$route.query.classe;
    this.classId = this.$route.params.id;
    const queryDate = this.$moment().format('L');
    this.getMinorsEvent({
      classroomId: this.classId,
      date: queryDate,
    });
  },
  methods: {
    ...mapActions('users', ['getMinorsEvent', 'getUserInfo']),
    getAbsence(data) {
      return data.absent ? `${this.$t('all.yes')}` : '—';
    },
    getPresence(data) {
      if (data.arrival_time && data.left_time) {
        return `${this.$t('all.entry')} ${data.arrival_time} — ${this.$t('all.uscita', )} ${data.left_time}`;
      } else if (data.arrival_time && !data.left_time) {
        return `${this.$t('all.entry')} ${data.arrival_time}`;
      }
      return '—';
    },
    decreaseDay() {
       this.registerDate = this.$moment(this.registerDate).subtract(1, 'days');
       this.registerDate = this.$moment(this.registerDate).utc().format();
      return this.registerDate;
    },
    increaseDay() {
      this.registerDate = this.$moment(this.registerDate).add(1, 'days');
      this.registerDate = this.$moment(this.registerDate).utc().format();
      return this.registerDate;
    },
    async selectDate() {
      const queryDate = this.$moment(this.registerDate).format('L');
      console.log(queryDate);
      await this.getMinorsEvent({
        classroomId: this.classId,
        date: queryDate,
      });
    },
  },
};
</script>
<style lang="scss">
.cell.day:not(.disabled) {
  &:hover,
  &.selected,
  &.highlighted {
    background: #e9494a;
    border: 1px solid #e9494a !important;
    border-radius: 100%;
    color: white;
  }
}
.vdp-datepicker__calendar {
  right: -46px;
}
.vdp-datepicker__calendar .cell.selected {
  background: #e9494a;
  border: 1px solid #e9494a !important;
  color: white;
}
</style>
